import useSWR from "swr";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

export interface CorporateMfaConfig {
  email_enabled: boolean;
  totp_enabled: boolean;
  mfa_configuration: "OFF" | "ON" | "OPTIONAL";
}

export const corporateMfaConfigUrl = (corporateId: string) =>
  `/usermgmt/admin/corporates/${encodeURIComponent(corporateId)}/mfa-config`;

export const useCorporateMfaConfig = (corporateId?: string) => {
  const { data, error, isLoading, mutate } = useSWR<CorporateMfaConfig | null>(
    corporateId ? corporateMfaConfigUrl(corporateId) : null,
    async (url: string) => {
      try {
        return await fetcher(url, MethodType.GET);
      } catch (error) {
        if (
          (error as { response?: { status?: number } })?.response?.status ===
          404
        ) {
          return null;
        }
        throw error;
      }
    },
    {
      keepPreviousData: false,
      // Consumers handle MFA failures locally, without the global error modal.
      onError: () => {},
    },
  );

  return {
    data,
    error,
    isLoading,
    isNotConfigured: data === null,
    mutate,
    totpEnabled: !error && data?.totp_enabled === true,
  };
};
